import {useMutation, useQueryClient} from 'react-query'
import {Settings} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: Settings) => {
    showNotification({
        title: 'Settings updated',
        icon: <Check/>,
        message: `The system settings have been updated!`,
    });
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the system settings. ${error}`,
        color: 'red'
    });
}

export default function useMutateEmailSettingsData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload admin data
            queryClient.invalidateQueries(['emailSettings']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
